<template>
  <div class="app-content">
    <div
      class="radius"
      style="
        width: 1000px;
        margin-top: 50px;
        line-height: 22px;
        font-size: 13px;
      "
    >
      <p style="font-size: 14px">
        <span class="title">本站线上协议规则</span>
      </p>
      <span style="margin-top: 10px"
        >為降低于本平台使用中发生的各类争议，请各位会员与代理在开始使用本平台前，详读下列内容。会员点击同意开始使用平台即被视为已接受所有协议与规定。</span
      >
      <ul class="list" style="list-style: outside disc">
        <li>
          会员与代理有责任确保自己的帐号、登陆与资金密码、银行卡资料的保密性，所有会员帐号在符合本平台下注规则内之一切投注，均视为有效。若会员或代理帐号被盗后，所进行的投注或因此导致的损失，本平台將不承担任何责任。若您发现或怀疑帐户资料被盗，请立即修改密码或通知在线客服。
        </li>
        <li>
          本平台开奖数据来自具有公信力的第三方公开的有效开奖结果，如发生开奖机构引起之开奖异常或时间延迟，本公司将不负担任何责任。
        </li>
        <li>
          本平台将不定期更换收款银行卡，会员在充值前有义务确认平台收款帐户，如会员向平台汇款充值，汇入错误银行或非最新公告之收款卡而导致损失，本公司将不承担责任，不予任何赔偿。
        </li>
        <li>
          为确保双方权益，若有发生不可抗拒之灾害导致网站故障、硬体损坏等情况，本公司将以最后备份之资料及会员投注后所储存的资料网站内"游戏记录"所记载，作为最后处理的依据。
        </li>
        <li>
          会员有责任在投注完成后，到"游戏记录"中确认该笔注单是否"下注成功"，且应仔细核对
          该笔注单之下注内容与金额．本公司仅以会员"游戏记录"的内容为计算结果之依据。
        </li>
        <li>
          所有赔率受多种因素影响时会随时变动。您所下注的赔率，将以显示"代购成功"后的注单为准。
        </li>
        <li>
          公布赔率时，出现任何的打字错误或非故意人为疏失，本公司将保留删除任何错误赔率注单的权利，并以"跑马灯"公布之，不个别另行通知。
        </li>
        <li>为避免争议，请会员于开始投注前，详细阅读本公司所定之各项规则。</li>
        <li>任何的投诉必须在开奖之前提出，本站不会受理任何开奖后的投诉。</li>
      </ul>
      <span class="title1">投注重要须知： </span>
      <ul style="list-style: outside disc">
        <li>当您在投注之后，请等待"恭喜，已为您代购成功！"的显示。</li>
        <li>单期派奖金额上限30万，超过30万以30万计算。</li>
        <li>
          如因断电、网路通讯故障、超过当期投注截止期、未成功付款、所投注号码被限号等原因造成未能及时将投注数据提交终端系统进行交易处理，本平台将作撤单返款处理，并发公告通知用户，除此之外，本平台不承担任何责任。
        </li>
        <li>提款标准为，充值金消费100％</li>
        <li>
          充值后使用下线充值且上下级消费未满100％即提款者，平台将酌收提款金额50％行政手续费。
        </li>
        <li>
          本公司一概不接受任何删单或修改之要求，请各位会员按照正常程序下注。
        </li>
        <li>
          本平台各游戏开奖时间皆以各游戏官方网站为主，如出现官方开奖延迟，造成延期开奖的情况，本站将于官网开奖完毕核实之后再另行开奖，由此造成的损失，本站概不负责。
        </li>
        <li>本平台保有修订、更新和修改本平台条款和游戏规则的权利。</li>
        <li>
          任何修订、更新和修改将于平台上公告，会员在上述修订、更新和修改后，若继续使用本平台进行游戏时，则视为会员同意并接受本平台之修订、更新和最终解释权。
        </li>
        <li>
          对于以上由本站所明列的协议和规则本人已详细阅读，若您点选下方同意进入后，即表示完全认可上述协议，与本网之规则与协助。
        </li>
      </ul>
      <div class="agreeBtn m-t-36">
        <button class="agree" @click="$emit('agree', 1)">同意进入</button>
        <button class="disagree" @click="$emit('agree', 0)">不同意</button>
      </div>
      <br class="clear" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AgreenContent',
};
</script>
